import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import useMount from 'hooks/useMount';
import useAuth, { AuthLoginSchemaType } from 'store/auth';

import sendMessage from '../common/sendMessage';
import { IMessageHandler } from '../common/types';
import addMessageHandler from '../common/listener';

import { IBiometric, IBiometricInfo, ReceiveBiometricMessages, SendBiometricMessages } from './types';

const useBiometric = (): IBiometric => {
  const [, authActions] = useAuth();
  const navigate = useNavigate();
  const [biometricInfo, setBiometricInfo] = useState<IBiometricInfo>({
    success: false,
    error: '',
    enabled: false,
  });

  const authenticate = (): void => {
    sendMessage({ type: SendBiometricMessages.biometricAuthenticate });
  };

  useMount(() => {
    const listener: IMessageHandler<ReceiveBiometricMessages> = async ({ type, payload }) => {
      switch (type) {
        case ReceiveBiometricMessages.enableBiometric: {
          await authActions.login(payload as AuthLoginSchemaType);
          navigate('/dashboard');
          break;
        }
        case ReceiveBiometricMessages.allowBiometric: {
          setBiometricInfo(payload as unknown as IBiometricInfo);

          if (localStorage.getItem('manualLogout')) {
            localStorage.removeItem('manualLogout');
            break;
          }

          if (payload.enabled) {
            authenticate();
          }
          break;
        }
        case ReceiveBiometricMessages.biometricAuthenticate: {
          if (!payload.success) {
            break;
          }
          await authActions.login(payload.params as AuthLoginSchemaType);
          navigate('/dashboard');
          break;
        }
        case ReceiveBiometricMessages.disableBiometric: {
          break;
        }
        default:
          break;
      }
    };
    sendMessage({ type: SendBiometricMessages.ready });

    return addMessageHandler(listener);
  });

  const enableBiometric = (payload: Record<string, string>): void =>
    sendMessage({ type: SendBiometricMessages.enableBiometric, payload });

  return { biometricInfo, enableBiometric, authenticate };
};

export default useBiometric;
